import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { HttpAuthService } from '../http-auth.service';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {
    constructor(private httpService: HttpAuthService, private router: Router) { }

    canActivate() {
        if (!this.httpService.isLogged()) {
            console.log("No estas logueado");
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}